import { render, staticRenderFns } from "./ModalDuplicatePolicy.vue?vue&type=template&id=1ea2458f&"
import script from "./ModalDuplicatePolicy.vue?vue&type=script&lang=js&"
export * from "./ModalDuplicatePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports